import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { transfer } from "../../rbac-consts";
import { default as ClientTransferContainer} from "./client/TransferContainer";
import { default as AdminTransferContainer } from "./admin/TransferContainer";

const TransferWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={transfer.USER}
        yes={() => (
          <ClientTransferContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={transfer.ADMIN}
        yes={() => (
          <AdminTransferContainer />
        )}
      />
    </>
  );
};

export default TransferWrapper;